import { useLang } from "@/i18n";
import { trackEvent, EVENTS } from "@/lib/analytics";
import { CTAButton } from "./ui";
import { Reveal } from "./Reveal";

export const DemoCta = () => {
  const { t } = useLang();
  const d = t.demoCta;
  return (
    <section data-testid="demo-cta-section" className="py-12 md:py-16 bg-navy-950">
      <div className="max-w-4xl mx-auto px-5 md:px-10 text-center">
        <Reveal>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-white leading-tight">{d.title}</h2>
          <p className="mt-4 text-base md:text-lg text-white/75 leading-relaxed max-w-2xl mx-auto">{d.text}</p>
          <div className="mt-7">
            <CTAButton
              href="#contact"
              data-testid="demo-cta-button"
              onClick={() => trackEvent(EVENTS.PRIMARY_CTA, { placement: "demo_section" })}
              className="w-full sm:w-auto justify-center min-h-[48px]"
            >
              {d.button}
            </CTAButton>
          </div>
          <p className="mt-4 text-xs text-white/50">{d.note}</p>
        </Reveal>
      </div>
    </section>
  );
};
